export default __webpack_public_path__ + "static/dots-d20800945c18e861cb615f95e91b65be.png";